export const MENSTRUAL_PHASES = ['Menstruation', 'Eisprung', 'Folikelphase', 'Luthealphase', 'None'];